/**
 * @generated SignedSource<<84b049be8f3a777ce173b3c8cca04631>>
 * @relayHash 0a68a91abafc7c22614c8b72a0a3f13b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFormsQuery } from './uiFormsQuery.graphql';

const node: PreloadableConcreteRequest<uiFormsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4",
    "metadata": {},
    "name": "uiFormsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
